<template>
  <div class="dados-pet-details">
    <page-header :title="title" />
    <page-section>
      <v-row no-gutters>
        <v-col class="mb-4" md="3">
          <field-section
            :is-restrict="$store.getters['pet/isRestrict']('nome')"
            :label="$t('Nome')"
            :value="pet.nome | toPT_BRCapitalize"
          />
        </v-col>
        <v-col class="mb-4" cols="6" md="3">
          <field-section
            :is-restrict="$store.getters['pet/isRestrict']('especie')"
            :label="$t('Especie')"
            :value="pet.especie | toPT_BRCapitalize"
          />
        </v-col>
        <v-col class="mb-4" cols="6" md="3">
          <field-section
            :is-restrict="$store.getters['pet/isRestrict']('raca')"
            :label="$t('Raca')"
            :value="pet.raca | toPT_BRCapitalize"
          />
        </v-col>
        <v-col class="mb-4" cols="6" md="3">
          <field-section
            :is-restrict="$store.getters['pet/isRestrict']('sexo')"
            :label="$t('Sexo')"
            :value="pet.sexo | toPT_BRCapitalize"
          />
        </v-col>
        <v-col class="mb-4" cols="6" md="3">
          <field-section
            :is-restrict="$store.getters['pet/isRestrict']('idade')"
            :label="$t('Idade')"
            :value="pet.idade"
          />
        </v-col>
        <v-col class="mb-4" cols="6" md="3">
          <field-section
            :is-restrict="$store.getters['pet/isRestrict']('chip')"
            :label="$t('Chip')"
            :value="pet.chip"
          />
        </v-col>
        <v-col class="mb-4" cols="6" md="3">
          <field-section
            :is-restrict="$store.getters['pet/isRestrict']('rga')"
            :label="$t('Rga')"
            :value="pet.rga"
          />
        </v-col>
        <v-col class="mb-4" cols="6" md="3">
          <field-section
            :is-restrict="$store.getters['pet/isRestrict']('statusPet')"
            :label="$t('Status_Pet')"
            :value="pet.statusPet | toPT_BRCapitalize"
          />
        </v-col>
      </v-row>
    </page-section>
    <page-section :group-label="$t('Dono_Cuidador')">
      <v-row no-gutters>
        <v-col cols="6" class="mb-4">
          <field-section
            :is-restrict="$store.getters['pet/isRestrict']('nomeDono')"
            :label="$t('Nome_Dono')"
            :value="pet.nomeDono | toPT_BRCapitalize"
          />
        </v-col>
        <v-col cols="6" class="mb-4">
          <field-section
            :is-restrict="$store.getters['pet/isRestrict']('foneDono')"
            :label="$t('Telefone_Dono')"
            :value="pet.foneDono"
          />
        </v-col>
        <v-col cols="6" class="mb-4">
          <field-section
            :label="$t('CEP')"
            :value="pet.cep"
            :is-restrict="$store.getters['pet/isRestrict']('cep')"
          />
        </v-col>
        <v-col cols="6" class="mb-4">
          <field-section
            :is-restrict="$store.getters['pet/isRestrict']('nomeCuidador')"
            :label="$t('Nome_Cuidador')"
            :value="pet.nomeCuidador | toPT_BRCapitalize"
          />
        </v-col>
        <v-col cols="6" class="mb-4">
          <field-section
            :is-restrict="$store.getters['pet/isRestrict']('foneCuidador')"
            :label="$t('Telefone_Cuidador')"
            :value="pet.foneCuidador"
          />
        </v-col>
      </v-row>
    </page-section>
    <Form :title="title" :data="pet" />
  </div>
</template>

<script>
import i18next from "i18next";
import PageHeader from "@/components/headers/page-header";
import PageSection from "@/components/sections/page-section";
import FieldSection from "@/components/sections/field-section";
import Form from "./form";

export default {
  metaInfo: {
    titleTemplate: (i18next.t("Dados_Pet") || "") + " | %s",
  },
  components: { FieldSection, PageSection, PageHeader, Form },
  data: () => ({
    title: i18next.t("Dados_Pet"),
  }),
  computed: {
    pet() {
      return this.$store.state.pet.data || {};
    },
  },
};
</script>

<style scoped></style>
